export default {"src":"/_next/static/media/student-control-panel.574a2bc2.svg","height":364,"width":665,"blurWidth":0,"blurHeight":0};